import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { doctorActions, patientActions, ehrActions } from "../../core/actions";
import TextField from "@mui/material/TextField";
import { InputLabel, FormControl, makeStyles } from "@material-ui/core";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { CASERECORD } from "../../shared/constants";
import { format } from "date-fns";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import { Alert } from "@mui/material";
import { helperServices } from "../../shared/helper";

function MnhNotes(props) {
  const dispatch = useDispatch();
  const [followUpDateFlag, setFollowUpDateFlag] = useState(false);
  const inputRefs = useRef([]);
  const [status, setStatus] = useState(undefined);
  const [todayDate, setTodayDate] = useState(new Date());
  const [revisitDate, setRevisitDate] = useState(
    format(new Date().setDate(new Date().getDate() + 14), "yyyy-MM-dd")
  );
  const [diagnosistemplate, setDiagnosistemplate] = useState();
  const [followUpdateFlag, setFollowUpdateFlag] = useState(true);
  const [patientDetail, setPatientDetail] = useState({
    patientId: "",
    lastvisitId: "",
    scheduleddate: "",
  });
  const [notes, setNotes] = useState({
    "Comment": "",
    "Follow Up Date": "",
  });
  const [showError, setShowError] = useState(false);
  const [ServerRes, setServerRes] = useState({ success: "", error: "" });
  const [loadsummary, setLoadSummary] = useState(false);
  const patientEhrid = useSelector((state) => state.patientDetailsState.ehrid);
  const [formErrors, setFormErrors] = useState({
    "Comment": "",
  });
  const [filterdProList, setfilterdProList] = useState();
  const [selectedDoctor, setSelectedDoctor] = useState("");
  const useStyles = makeStyles((theme) => ({
    redAsterisk: {
      color: "red",
    },
  }));

  const classes = useStyles();

  useEffect(() => {
    console.log("props data is : ", props);
    let patientId = props.patientData.id;
    let visitId = props.patientData.visit.id;
    dispatch(
      patientActions.getrevisitbyId(patientId, visitId, (resCb) => {
        if (resCb) {
          console.log("resCb doctor Response:", resCb);
          console.log("resCbe : ", resCb);
          patientDetail["scheduleddate"] = resCb.scheduleddate;
          if (
            patientDetail["scheduleddate"] !== " " &&
            patientDetail["scheduleddate"] !== undefined &&
            patientDetail["scheduleddate"] !== null
          ) {
            setRevisitDate(
              format(new Date(patientDetail["scheduleddate"]), "yyyy-MM-dd")
            );
            console.log(
              "resCbe : ",
              revisitDate,
              patientDetail["scheduleddate"]
            );
          } else {
            setRevisitDate(
              format(
                new Date().setDate(new Date().getDate() + 14),
                "yyyy-MM-dd"
              )
            );
          }
        }
      })
    );

    console.log("diagnosis template:", patientDetail);
    getNotesDetails();
    getDiagnosistemplateById();
    console.log("diagnosis template:", diagnosistemplate);
  }, []);

  const getNotesDetails = () => {
    props.patientData.patientId = props.patientData.id;
    props.patientData.visitId = props.patientData.visit.id;
    props.patientData.groupname = CASERECORD;
    console.log("details :: ", props.patientData);
    dispatch(
      patientActions.getDischargeSummary(notes, props.patientData, (resCb) => {
        if (resCb) {
          console.log("resCb doctor Response:", resCb);
          if (resCb.procedureList) {
            const filterList = resCb.procedureList.filter(
              (items) => items.groupname === CASERECORD
            );
            const keys = Object.keys(notes);
            var patientNotes = { ...notes };
            if(resCb)
            var filteredProList = [];
            filterList.forEach((item) => {
              for (let key of keys) {
                if (item.claSS == key) {
                  patientNotes[key] = item.notes;
                  filteredProList.push(item);
                  setNotes({ ...patientNotes });
                }
              }
              setfilterdProList([...filteredProList]);
            });
          }
          if(resCb && resCb.vaList && resCb.vaList[0]){
            console.log("resCb.vaList[0]",resCb.vaList[0].targetid);
            getDoctorsList(resCb.vaList[0].targetid);
          }
        }
      })
    );
  };
  
  const closeServiceModal = (event) => {
    props.onModalClose(event);
  };

  const saveDiagnosisinEHR = (finaldiagnosis) => {
    let responseresCb = {};

    console.log("---Form changed---", diagnosistemplate);
    console.log("---patientEhrid---", patientEhrid);

    let templateId = "Diagnosis";
    let patientId = props.patientData.id;
    let visitId = props.patientData.visit.id;

    console.log("patientidddd", patientId);
    console.log("visitIdddd", visitId);
    console.log("Templateiddddd", diagnosistemplate.content[0].data);
    diagnosistemplate.content[0].subject.name=selectedDoctor
    for (let item of diagnosistemplate.content[0].data.items) {
      console.log("ii", item);
      let element = item.name.value;
      console.log("Elementtttooo", element);
      const time = new Date(
        new Date().toLocaleString("en-US", { timeZone: "Asia/Kolkata" })
      ).toISOString();
      switch (element) {
        case "Problem/Diagnosis name":
          item.value.value = "Diagnosis";
          break;
        case "Clinical description":
          item.value.value = finaldiagnosis.notes;
          break;

        case "Date/time of onset":
          item.value.value = time;
          break;

        case "Date/time of resolution":
          item.value.value = time;
          break;
        case "Date/time clinically recognised":
          item.value.value = time;
          break;

        default:
      }
      console.log("---Form changed---", diagnosistemplate);
    }

    let notesDetails = finaldiagnosis.notes ? finaldiagnosis.notes : "NA";
    let procedure = props.selectedProcedure ?? null;
    dispatch(
      ehrActions.saveComposition(
        diagnosistemplate,
        patientId,
        visitId,
        templateId,
        patientEhrid,
        notesDetails,
        procedure,
        (resCb) => {
          if (resCb) {
            console.log("Diagnosis Master API Response:", resCb);
            console.log("Templateiddddd", templateId);
            if (resCb.successMessages) {
              props.onModalClose({ success: resCb.successMessages[0] });
            } else {
              if (resCb.errorMessages[0]) {
                props.onModalClose({ error: resCb.errorMessages[0] });
              }
            }
          }
        }
      )
    );
  };

  const getDiagnosistemplateById = () => {
    let data = "";
    const jsonSchema = {};
    let templateId = "Diagnosis";
    let patient = {};
    dispatch(
      ehrActions.getTemplateById(data, templateId, patient, (resCb) => {
        if (resCb) {
          console.log("Getdiagnosiss rescb", resCb);
          console.log("Diagnosisss ", resCb);
          setDiagnosistemplate(resCb);
        }
      })
    );
    return diagnosistemplate;
  };

  const handleInputChange = (name, value) => {
    setShowError(false);
    console.log("In handleinput change", name, value);
    let updatedFormErrors = { ...formErrors };
    if (value.length > 800) {
      updatedFormErrors[name] = name + " exceeds limit of 800 characters";
    } else {
      updatedFormErrors[name] = "";
    }
    setFormErrors(updatedFormErrors);
    formErrors[name] = "";
    var patientNotes = notes;
    var keyList = [];
    patientNotes[name] = value;
    
    if (filterdProList && filterdProList.length > 0) {
      filterdProList.forEach((item) => {
        if (item.claSS == name) {
          keyList.push({
            claSS: item.claSS,
            notes: value,
            id: item.id,
            patientId: item.patientId,
            visitId: item.visitId,
          });
        }
        setfilterdProList([...keyList]);
      });
    }
    setNotes({ ...patientNotes });
  };

  const handleSubmit = (e) => {
    validateForm(e);
    setTimeout(() => {
      console.log("props:", props);
    }, 3000);
  };

  const setMessageStrip = (e) => {
    console.log("message obtained", e);
    var ServerResVal = ServerRes;
    if (e.success) {
      console.log("success message:", e.success);
      ServerResVal.success = e.success;
    } else {
      console.log("error message:", e.error);
      ServerResVal.error = e.error;
    }
    setServerRes({ ...ServerResVal });
    setTimeout(() => {
      closeAlert();
    }, 5000);
  };

  const UpdateRevisitDetails = () => {
    console.log(" insert  props", props);
    patientDetail.patientId = props.patientData.id;
    patientDetail.lastvisitId = props.patientData.visit.id;
    console.log("patientdetail.....", patientDetail, revisitDate);

    let date = format(new Date(revisitDate), "dd-MM-yyyy");

    notes["Follow Up Date"] = date;
    patientDetail.scheduleddate = date;
    setFollowUpdateFlag(date);
    console.log("notes adte:", notes["Follow Up Date"]);
    return patientDetail;
  };

  const closeAlert = (e) => {
    setServerRes({ ..."" });
  };

  const validateForm = (e) => {
    console.log("Submit Notes:", e);
    console.log("formErrors : ", formErrors);
    
    // Check for character limit error
    for (let key in formErrors) {
      if (formErrors[key] !== "") {
        setMessageStrip({
          error: "Please check there is a validation error in the notes form",
        });
        return;
      }
    }
    setShowError(false);

    var ServerResVal = ServerRes;
    e.preventDefault();
    var proList = [];
    let finaldiagnosis = {};
    const followUpDetails = UpdateRevisitDetails();
    const keys = Object.keys(notes);

    if (filterdProList && filterdProList.length > 0) {
      filterdProList.forEach((item) => {
        if (item.claSS === "Follow Up Date") {
          proList.push({
            id: item.id,
            claSS: item.claSS,
            notes: followUpDetails.scheduleddate,
            patientId: item.patientId,
            visitId: item.visitId,
          });
        } else {
          proList.push({
            id: item.id,
            claSS: item.claSS,
            notes: item.notes,
            patientId: item.patientId,
            visitId: item.visitId,
          });
        }
      });
      console.log("proList in edit case: ", proList);
    } else {
      for (let key of keys) {
        proList.push({
          claSS: key,
          notes: notes[key],
          patientId: props.patientData.id,
          visitId: props.patientData.visit.id,
        });
        console.log("proList in add case: ", proList);
      }
    }
    notes["notes"] = "NOTE";
    // Find comment for final diagnosis
    // proList.map((item) => {
    //   if (item.claSS === "Comment") {
    //     finaldiagnosis = item;
    //     console.log("hellowww", finaldiagnosis);
    //   }
    // });
    
    dispatch(
      doctorActions.addCaseRecord(proList, (resCb) => {
        if (resCb) {
          console.log("resCb doctor Response:", resCb);
          if (resCb.successMessages) {
            console.log(
              "finaldiagnosis",
              finaldiagnosis,
              finaldiagnosis ? finaldiagnosis.notes : undefined
            );
            if (
              finaldiagnosis &&
              finaldiagnosis.notes !== "" &&
              finaldiagnosis.notes !== undefined
            ) {
              saveDiagnosisinEHR(finaldiagnosis);
            }

            props.onModalClose({ success: "Notes added successfully" });
          } else {
            props.onModalClose({ error: "Failed to add notes" });
          }
          console.log("resCbe : ", resCb);
        }
      })
    );
    setMessageStrip({ success: e.successMessages });
    setServerRes({ ...ServerResVal });

    setTimeout(() => {
      closeAlert();
    }, 3000);
  };

  const ChangeRevisitDate = (event) => {
    console.log("date: ", event.target.value);
    setRevisitDate(event.target.value);
  };

  const getDoctorsList = (targetid,data) => {
    let gvdata;
    dispatch(
      doctorActions.getDoctorList(data, (resCb) => {
        if (resCb) {
          let list = [];
          console.log("rescb from getdoctorlist: ", resCb);
          for (let doc of resCb) {
            if (doc != null) {
              let opt = {};
              if (doc && !doc.first_name) {
                doc.first_name = "";
              }
              if (doc && !doc.last_name) {
                doc.last_name = "";
              }
              if (doc && doc.gvId) {
                opt["id"] = doc.personId;
                opt["gvid"] = doc.gvId;
              }
              const name = helperServices.getFullName(
                doc.first_name,
                null,
                doc.last_name
              );
              opt["role"] = doc.role;
              opt["type"] = doc.type;
              opt["value"] = doc.email;
              opt["department"] = doc.department;
              opt["firstName"] = doc.first_name;
              opt["lastName"] = doc.last_name;
              opt["departmentId"] = doc.departmentId;
              opt["label"] =
                doc.displaytitle +
                "." +
                " " +
                name +
                ", " +
                "Dep of " +
                doc.department +
                " (" +
                doc.qualification +
                " )";
              list.push(opt);
              gvdata = targetid;
              console.log("gvdata and doc: ", gvdata, doc);
              if (gvdata && gvdata == doc.personId) {
                setSelectedDoctor(doc.displaytitle+". "+ name);
              }
            }
          }
        }
      })
    );
  };

  return (
    <>
      {ServerRes.error && (
        <Alert severity="error" className="alert-div">
          {ServerRes.error}{" "}
          <IconButton
            aria-label="close"
            color="inherit"
            size="small"
            onClick={(event) => closeAlert(event)}
          >
            <CloseIcon fontSize="inherit" />
          </IconButton>
        </Alert>
      )}
      <div className=" bg-none nav-wrapper h-100 d-flex flex-column service-view">
        <div className='"d-flex'>
          <IconButton
            aria-label="close"
            onClick={(event) => closeServiceModal(event)}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </div>

        <div
          className="w-100 service-container service-container1"
          style={{ overflowY: "auto" }}
        >
          <div className="d-flex m-3 justify-content-between px-4">
            <div className="w-100 flex-wrap flex-column">
              <Box className="row service-form">
                {showError && (
                  <div className="text-danger my-4">
                    All fields can not be empty!
                  </div>
                )}

                <div
                  id="notespadding"
                  className="pl-0  col-lg-6 col-xl-6 col-md-6 col-12 pt-2"
                >
                  <TextField
                    fullWidth
                    className="p-2"
                    value={notes["Comment"]}
                    placeholder="Please Type Comment here..."
                    autoComplete="off"
                    type="text"
                    onChange={(event) => {
                      handleInputChange("Comment", event.target.value);
                    }}
                    label={<span>Comment </span>}
                    error={formErrors["Comment"] !== ""}
                    invalid={
                      formErrors["Comment"] === "" ? false : true
                    }
                    multiline
                    minRows={1}
                    maxRows={10}
                  />
                  <div style={{ color: "#EC4147" }}>
                    <span className="service-lable">
                      {formErrors["Comment"]}
                    </span>
                  </div>
                </div>

                <div
                  id="notespadding"
                  className="pl-0 col-lg-6 col-xl-6 col-md-6 col-12 "
                >
                  <label className="service-lable mb-0">Follow Up Date</label>
                  <input
                    name="scheduleddate"
                    id="scheduleddate"
                    className="form-control filterin Quantity"
                    placeholder="Enter ScheduledTime"
                    required
                    type="date"
                    readOnly={followUpDateFlag}
                    min={todayDate}
                    defaultValue={
                      patientDetail["scheduleddate"] === undefined
                        ? revisitDate
                        : patientDetail["scheduleddate"]
                    }
                    onChange={ChangeRevisitDate}
                  />
                </div>
              </Box>

              <div className="d-inline-block text-left my-4  savebutton">
                <Button
                  id="we"
                  type="submit"
                  color="primary"
                  variant="contained"
                  sx={{ textTransform: "capitalize" }}
                  className=" btn-primary"
                  onClick={(event) => handleSubmit(event)}
                >
                  Save
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default MnhNotes;